import type { FC } from 'react';
import React from 'react';

import { ICON_SIZE_MAP } from '../../../constants';
import { PictureInPictureIcon } from '../../assets/PictureInPictureIcon';
import { Tooltip } from '../Tooltip/Tooltip';

import styles from './PictureInPictureToggle.module.scss';

type PictureInPictureToggleProps = {
  size: 'medium' | 'large';
  isPictureInPicture: boolean;
  onPictureInPictureToggle: () => void;
};

export const PictureInPictureToggle: FC<PictureInPictureToggleProps> = ({
  size,
  isPictureInPicture,
  onPictureInPictureToggle,
}) => {
  const iconSize = ICON_SIZE_MAP[size];
  const tooltipContent = 'Picture in picture';
  const ariaLabel = isPictureInPicture
    ? 'Exit picture in picture'
    : 'Enter picture in picture';

  return (
    <Tooltip content={tooltipContent}>
      <button
        className={styles.button}
        type="button"
        tabIndex={0}
        aria-label={ariaLabel}
        onClick={onPictureInPictureToggle}
      >
        <PictureInPictureIcon width={iconSize} height={iconSize} />
      </button>
    </Tooltip>
  );
};
